export default {
  primary: '#1857b6',
  secondary: '#0f3875',
  yellow: '#F4D35E',
  paleYellow: '#faeebe',
  mediumYellow: '#f8de8e',
  red: '#f7605f',

  black: '#000000',
  white: '#FFFFFF',

  grey: '#A5A5A5',
  slate: '#616161',
  lightGrey: '#E8E8E8',
  darkGrey: '#555555',

  breakpoints: {
    singleColumn: 720,
  },
};
